import type { SteeringActionType } from '../types';
import type { ActionHandler } from './types';
import { connectCalendarHandler } from './connectCalendar';

const notImplemented: ActionHandler = {
  getHref: () => {
    throw new Error('Action handler not implemented');
  },
  getFollowUp: () => {
    throw new Error('Action handler not implemented');
  },
  completionEvents: [],
};

export const actionRegistry: Record<SteeringActionType, ActionHandler> = {
  CONNECT_CALENDAR: connectCalendarHandler,
  CREATE_CLIENT: notImplemented,
  CREATE_MEETING_AGENDA: notImplemented,
  CREATE_MEETING_NOTES: notImplemented,
  DATA_UPLOAD_FROM_MEETING: notImplemented,
  DATA_UPLOAD: notImplemented,
  CREATE_SUITABILITY_REPORT: notImplemented,
};
